import {
    Component,
    OnDestroy,
    OnInit,
    inject,
    input,
    ChangeDetectionStrategy
} from "@angular/core";
import { Subject } from "rxjs";
import { filter, map, takeUntil } from "rxjs/operators";
import { PermittedDirective } from "~app/common/directives/permitted/permitted.directive";
import { RaskRoller } from "~app/common/models/constants";
import { IVirkeskopKontraktEntityDTO } from "~app/common/models/entity-models";
import { canEdit, providePermissions } from "~app/role-permissions";
import { Kontrakt } from "../../models/kontrakt-models";
import { AvverkningskostnaderMediatorService } from "../../services/avverkningskostnader-mediator.service";
import { DigitalSigneringMediatorService } from "../../services/digitalsignering-mediator.service";
import { KontraktBilagorService } from "../../services/kontrakt-bilagor.service";
import { KontraktMediatorService } from "../../services/kontrakt-mediator.service";
import { KontraktStatusService } from "../../services/kontrakt-status.service";
import { LeveransvirkesvolymMediatorService } from "../../services/leveransvirkesvolym-mediator.service";
import { MatbeskedMediatorService } from "../../services/matbesked-mediator.service";
import { SkogsvardBetalningMediatorService } from "../../services/skogsvard-betalning-mediator.service";
import { UtskriftMediatorService } from "../../services/utskrift-mediator.service";
import { VirkeskostnaderMediatorService } from "../../services/virkeskostnader-mediator.service";
import { SkogsvardListComponent } from "../../skogsvard/skogsvard-list/skogsvard-list.component";
import { KontraktCertifieringComponent } from "../certifiering/kontrakt-certifiering/kontrakt-certifiering.component";
import { KontraktBilagorComponent } from "../kontrakt-bilagor/kontrakt-bilagor.component";
import { KontraktHeaderComponent } from "../kontrakt-header/kontrakt-header.component";
import { KontraktUtskriftDokumentComponent } from "../kontrakt-utskrift-dokument/kontrakt-utskrift-dokument.component";
import { KontraktUtskriftComponent } from "../kontrakt-utskrift/kontrakt-utskrift.component";
@Component({
    selector: "rask-skogsvard-fpv-kontrakt",
    templateUrl: "./skogsvard-fpv-kontrakt.component.html",
    styleUrls: ["./skogsvard-fpv-kontrakt.component.scss"],
    providers: [
        AvverkningskostnaderMediatorService,
        DigitalSigneringMediatorService,
        KontraktBilagorService,
        KontraktStatusService,
        LeveransvirkesvolymMediatorService,
        MatbeskedMediatorService,
        SkogsvardBetalningMediatorService,
        UtskriftMediatorService,
        VirkeskostnaderMediatorService,
        providePermissions({
            role: RaskRoller.role.Skogsvardsuppdragsplanera,
            canEdit: true
        })
    ],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [
        KontraktHeaderComponent,
        SkogsvardListComponent,
        KontraktCertifieringComponent,
        KontraktUtskriftComponent,
        KontraktUtskriftDokumentComponent,
        KontraktBilagorComponent,
        PermittedDirective
    ]
})
export class SkogsvardFpvKontraktComponent implements OnInit, OnDestroy {
    readonly entity = input.required<IVirkeskopKontraktEntityDTO>();

    protected kontrakt: Kontrakt;
    protected kontraktReadonly = false;

    private readonly kontraktMediatorService = inject(KontraktMediatorService);
    private readonly ngUnsubscribe$ = new Subject<void>();

    private readonly canEdit = canEdit();

    ngOnInit(): void {
        this.kontraktMediatorService.kontrakt$.pipe(
            filter(k => k !== null),
            takeUntil(this.ngUnsubscribe$)
        ).subscribe(k => this.kontrakt = k);

        this.kontraktMediatorService.isReadonly$.pipe(
            map(readonly => readonly || !this.canEdit()),
            takeUntil(this.ngUnsubscribe$)
        ).subscribe(readonly => this.kontraktReadonly = readonly);
    }

    ngOnDestroy(): void {
        this.ngUnsubscribe$.next();
        this.ngUnsubscribe$.complete();
    }
}
